import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.array.fill";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import * as types from "@/store/constants/types";

var RadarChart =
/*#__PURE__*/
function (_Vue) {
  _inherits(RadarChart, _Vue);

  function RadarChart() {
    var _this;

    _classCallCheck(this, RadarChart);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RadarChart).apply(this, arguments));
    _this.ctx = null;
    _this.cavsWidth = 260;
    _this.cavsHeight = 260;
    _this.radCenter = 130;
    _this.lineCount = 6;
    _this.radDeg = Math.PI * 2 / 6;
    _this.purpleBgColor = '#F3F1FF';
    _this.purpleLineColor = "#E2DBFF";
    _this.whiteBg = "#fff";
    _this.circleRadList = [29, 45, 61, 77];
    _this.textColor = 'rgb(99,98,104)';
    return _this;
  }

  _createClass(RadarChart, [{
    key: "renderTimeChange",
    value: function renderTimeChange(val, oldVal) {
      var _this2 = this;

      if (val) {
        this.$nextTick(function () {
          _this2.initCanvas();
        });
      }
    }
  }, {
    key: "mounted",
    value: function mounted() {}
  }, {
    key: "activated",
    value: function activated() {}
  }, {
    key: "initCanvas",
    value: function initCanvas() {
      var cavs = this.$refs.radarChart;

      if (cavs) {
        this.ctx = cavs.getContext('2d'); //获取画笔

        if (window.devicePixelRatio) {
          //清除canvas在移动端的锯齿
          cavs.style.width = this.cavsWidth + "px";
          cavs.style.height = this.cavsHeight + "px";
          cavs.width = this.cavsWidth * window.devicePixelRatio;
          cavs.height = this.cavsHeight * window.devicePixelRatio;
          this.ctx.scale(window.devicePixelRatio, window.devicePixelRatio);
        } //先画最底层的


        this.drawPolygon(this.ctx); //虚线在底层的框之上

        this.drawLines(this.ctx); //画文字

        this.drawText(this.ctx);
        this.drawRegion(this.ctx);
        this.drawCircle(this.ctx);

        if (this.averageRate !== -1) {
          this.drawAverageText(this.ctx);
        }
      }
    } // 绘制多边形边

  }, {
    key: "drawPolygon",
    value: function drawPolygon(ctx) {
      ctx.save();
      ctx.strokeStyle = this.purpleBgColor; //画4个圆

      for (var i = 4; i > 0; i--) {
        //由于有填充色，需要从外层的圆开始画
        ctx.beginPath();
        var currR = this.circleRadList[i - 1]; //画6条边

        for (var j = 0; j < this.lineCount; j++) {
          var x = this.radCenter + currR * Math.sin(this.radDeg * j);
          var y = this.radCenter + currR * Math.cos(this.radDeg * j);
          ctx.lineTo(x, y);
        }

        ctx.closePath();
        ctx.lineWidth = i === 4 ? 2.5 : 0.5;
        ctx.fillStyle = i % 2 === 0 ? this.whiteBg : this.purpleBgColor;
        ctx.stroke();
        ctx.fill();
      }

      ctx.restore();
    } //顶点连线

  }, {
    key: "drawLines",
    value: function drawLines(ctx) {
      ctx.save();
      ctx.beginPath();
      ctx.strokeStyle = this.purpleLineColor;
      ctx.setLineDash([3, 5]);

      for (var i = 0; i < this.lineCount; i++) {
        var x = this.radCenter + this.circleRadList[this.circleRadList.length - 1] * Math.sin(this.radDeg * i); //4表示最外层的

        var y = this.radCenter + this.circleRadList[this.circleRadList.length - 1] * Math.cos(this.radDeg * i);
        ctx.moveTo(this.radCenter, this.radCenter);
        ctx.lineTo(x, y);
      }

      ctx.stroke();
      ctx.restore();
    } //绘制文本

  }, {
    key: "drawText",
    value: function drawText(ctx) {
      ctx.save();
      ctx.textAlign = 'center';

      for (var i = 0; i < this.lineCount; i++) {
        var x = this.radCenter + this.circleRadList[this.circleRadList.length - 1] * Math.sin(Math.PI - this.radDeg * i);
        var y = this.radCenter + this.circleRadList[this.circleRadList.length - 1] * Math.cos(Math.PI - this.radDeg * i);

        if (i === 0) {
          ctx.font = '16px Assistant-Regular';
          ctx.fillStyle = this.textColor;
          ctx.fillText(this.$t("common." + this.radarDate[i].text.toLowerCase().replace(' ', "_")), x, y - 16 * 2.4);
          ctx.font = '18px Assistant-SemiBold';
          ctx.fillStyle = this.radarDate[i].rateColor;
          ctx.fillText(this.radarDate[i].rate, x, y - 16);
        } else if (i === 1 || i === 2) {
          ctx.font = '16px Assistant-Regular';
          ctx.fillStyle = this.textColor;
          ctx.fillText(this.$t("common." + this.radarDate[i].text.toLowerCase().replace(' ', "_")), x + 30, y - 16 * .7);
          ctx.font = '18px Assistant-SemiBold';
          ctx.fillStyle = this.radarDate[i].rateColor;
          ctx.fillText(this.radarDate[i].rate, x + 30, y + 16 * .7);
        } else if (i === 3) {
          ctx.font = '16px Assistant-Regular';
          ctx.fillStyle = this.textColor;
          ctx.fillText(this.$t("common." + this.radarDate[i].text.toLowerCase().replace(' ', "_")), x, y + 16 * 1.5);
          ctx.font = '18px Assistant-SemiBold';
          ctx.fillStyle = this.radarDate[i].rateColor;
          ctx.fillText(this.radarDate[i].rate, x, y + 16 * 3);
        } else {
          ctx.font = '16px Assistant-Regular';
          ctx.fillStyle = this.textColor;
          ctx.fillText(this.$t("common." + this.radarDate[i].text.toLowerCase().replace(' ', "_")), x - 30, y - 16 * .7);
          ctx.font = '18px Assistant-SemiBold';
          ctx.fillStyle = this.radarDate[i].rateColor;
          ctx.fillText(this.radarDate[i].rate, x - 30, y + 16 * .7);
        }
      }

      ctx.restore();
    } //绘制数据区域

  }, {
    key: "drawRegion",
    value: function drawRegion(ctx) {
      ctx.save();
      ctx.beginPath();

      for (var i = 0; i < this.lineCount; i++) {
        var x = this.radCenter + this.circleRadList[this.circleRadList.length - 1] * Math.sin(Math.PI - this.radDeg * i) * this.radarDate[i].percent;
        var y = this.radCenter + this.circleRadList[this.circleRadList.length - 1] * Math.cos(Math.PI - this.radDeg * i) * this.radarDate[i].percent;
        ctx.lineTo(x, y);
      }

      ctx.closePath();
      var grad = ctx.createLinearGradient(60, 70, 180, 150); //创建一个渐变色线性对象

      grad.addColorStop(0, 'rgba(170, 102, 255, 0.7)'); //定义渐变色颜色

      grad.addColorStop(1, 'rgba(86, 59, 254, 0.7)');
      ctx.fillStyle = grad;
      ctx.fill();
      ctx.restore();
    } //画点

  }, {
    key: "drawCircle",
    value: function drawCircle(ctx) {
      ctx.save();
      var r = 2;

      for (var i = 0; i < this.lineCount; i++) {
        var x = this.radCenter + this.circleRadList[this.circleRadList.length - 1] * Math.sin(Math.PI - this.radDeg * i) * this.radarDate[i].rate / 5;
        var y = this.radCenter + this.circleRadList[this.circleRadList.length - 1] * Math.cos(Math.PI - this.radDeg * i) * this.radarDate[i].rate / 5;
        ctx.beginPath();
        ctx.arc(x, y, r, 0, Math.PI * 2);
        ctx.fillStyle = '#603BF3';
        ctx.fill();
      }

      ctx.restore();
    }
  }, {
    key: "drawAverageText",
    value: function drawAverageText(ctx) {
      this.ctx.font = '44px Assistant-SemiBold';
      this.ctx.fillStyle = '#fff';
      this.ctx.textAlign = 'center';
      this.ctx.fillText(this.averageRate, 130, 146);
    }
  }]);

  return RadarChart;
}(Vue);

tslib_1.__decorate([Getter(types.GETTER_TODAY_HOROSCOPE_FATE)], RadarChart.prototype, "dotayHoroFate", void 0);

tslib_1.__decorate([Prop({
  default: []
})], RadarChart.prototype, "radarDate", void 0);

tslib_1.__decorate([Prop({
  default: -1
})], RadarChart.prototype, "renderTime", void 0);

tslib_1.__decorate([Prop({
  default: -1
})], RadarChart.prototype, "averageRate", void 0);

tslib_1.__decorate([Watch('renderTime', {
  immediate: true
})], RadarChart.prototype, "renderTimeChange", null);

RadarChart = tslib_1.__decorate([Component({
  components: {}
})], RadarChart);
export default RadarChart;